import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { Box, Typography } from "@mui/material";
import React, { Fragment } from "react";
import EyeIco from "../../../../assets/icons/EyeIco";
import CommonButton from "../../../../component/Button";
import CommonLinearProgress from "../../../../component/Linearprogress";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CommonTippy, CustomizeSpan } from "../../../jobs/style";
import { StyledLinearContainer } from "../../../matches/quick-match/components/StyledComponent";

export default function CandidateProgress({ checkSelected, handleViewClick }) {
  return (
    <Fragment>
      {checkSelected &&
        checkSelected.map((item, index) => {
          return (
            <CommonGrid2
              container
              spacing={2}
              justifyContent={"space-between"}
              marginTop={2}
              alignItems={"center"}
              borderRadius="10px"
              border={"1px solid #EAECF0"}
              padding={"10px"}
            >
              {item.result_title === "Candidate Search Results" && (
                <CommonGrid2
                  size={12}
                  display={"flex"}
                  gap={"1rem"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <CommonGrid2
                    display={"flex"}
                    flexDirection={"column"}
                    gap="5px"
                  >
                    <Typography variant="h5">
                      {item?.name || item?.title}
                    </Typography>
                    <CustomizeSpan
                      variant="body4"
                      color="#7F56D9"
                      fontWeight={600}
                    >
                      {item?.client} {" - "}
                      <Typography variant="body4" color="#667085">
                        {item?.order_no}
                      </Typography>
                    </CustomizeSpan>
                  </CommonGrid2>
                  <CommonButton
                    value={"View Job"}
                    padding={"8px 1rem"}
                    gap={"0px"}
                    startIcon={<EyeIco />}
                    disabled={item?.file?.progress !== 100}
                    customStyle={{
                      "& svg path": {
                        stroke: "#fff",
                      },
                    }}
                    onClick={() => handleViewClick(item)}
                  />
                </CommonGrid2>
              )}
              <CommonGrid2 item size={12}>
                {item.file && (
                  <Box width={"100%"}>
                    {item.file.progress === 100 ? (
                      <CommonGrid2 display={"flex"} gap={"10px"}>
                        <TaskAltIcon sx={{ color: "#17B26A" }} />
                        <Typography variant="h5" color="#17B26A">
                          Added to Job
                        </Typography>
                      </CommonGrid2>
                    ) : (
                      <Fragment>
                        <Typography
                          color="#475467"
                          fontSize={"14px"}
                          fontWeight={500}
                        >
                          {item.file.size}
                        </Typography>
                        {(item.file.progress >= 0 || item.file.visible) && (
                          <Fragment>
                            <CommonTippy
                              content={item.file.message}
                              visible={item.file.visible}
                              interactive={true}
                              trigger="click"
                              hideOnClick={false}
                              zIndex={2}
                              color="red"
                            >
                              <StyledLinearContainer>
                                <CommonLinearProgress
                                  variant={
                                    item.file.progress && !item.file.visible
                                      ? "buffer"
                                      : "determinate"
                                  }
                                  value={item.file.progress}
                                  valueBuffer={item.file.buffer}
                                  height={"8px"}
                                  borderRadius={"2px"}
                                  backgroundColor={"#E0E0E0"}
                                  barbackgroundColor={
                                    item.file.visible ? "red" : "#7F56D9"
                                  }
                                  dashedmarginTop={"2px"}
                                  dashedbackgroundImage={
                                    item.file.visible
                                      ? "radial-gradient(rgb(255 46 0) 0%, rgb(255 0 0) 16%, #00000000 42%)"
                                      : "radial-gradient(rgb(82 0 255) 0%, rgb(82 0 255) 16%, #00000000 42%)"
                                  }
                                />

                                <Typography
                                  color="#344054"
                                  fontSize={"14px"}
                                  fontWeight={500}
                                >
                                  {item.file.progress}%
                                </Typography>
                              </StyledLinearContainer>
                            </CommonTippy>
                            {item.file.progress_message && (
                              <CustomizeSpan
                                fontSize="12px"
                                color="#475467"
                                sx={{
                                  letterSpacing: "0.2px",
                                  animation: "wave 1.5s ease-in-out infinite",
                                  "@keyframes wave": {
                                    "0%, 100%": { transform: "translateY(0)" },
                                    "50%": { transform: "translateY(-4px)" },
                                  },
                                }}
                              >
                                {item.file.progress_message} . . .
                              </CustomizeSpan>
                            )}
                          </Fragment>
                        )}
                      </Fragment>
                    )}
                  </Box>
                )}
              </CommonGrid2>
            </CommonGrid2>
          );
        })}
    </Fragment>
  );
}
